import { useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"
import { toast } from "sonner"
import openAuth from "./openAuth"
import useRedirectAfterLogin from "./useRedirectAfterLogin"
import type { SocialProvider } from "./model"
import { useConnectOauthMutation } from "./api"
import { useTokenRefreshMutation } from "@/base/baseApi"

export default () => {
  const [connect, { isLoading: isConnecting }] = useConnectOauthMutation()
  const [tokenRefresh] = useTokenRefreshMutation()
  const navigate = useNavigate()
  const { getRedirectUrl } = useRedirectAfterLogin()

  const handleConnect = useCallback(
    (provider: SocialProvider) => {
      openAuth(
        async () => {
          const { authUrl } = await connect({
            provider,
            // TODO: Move this to a generateUrl util
            returnUrl: window.location.origin + "/auth/oauth-result",
          }).unwrap()

          return authUrl
        },
        async (result) => {
          switch (result.result) {
            case "success":
              await tokenRefresh(result.refreshToken).unwrap()
              await navigate({
                to: getRedirectUrl(),
                replace: true,
              })

              return
            case "cancelled":
              return
            case "error":
              toast.error(result.error || "Authentication Failed.")

              return
          }
        },
      )
    },
    [connect, tokenRefresh, navigate, getRedirectUrl],
  )

  return { handleConnect, isConnecting }
}
